import {Component, OnInit, AfterViewInit, inject} from '@angular/core';
import {Router} from '@angular/router';
import {ListItemRendererComponent} from 'gung-list';
import {EdiMessageBase, EdiPurchaseOrder} from '../../../models/edi';
import {
  EdiPurchasedOrderActionConfigService
} from "../../../services/edi-purchased-order-action-config/edi-purchased-order-action-config.service";
import { EdiNavigationService } from '../../../services/edi/edi-navigation.service';

@Component({
    selector: 'lib-edi-purchased-order-card-list',
    templateUrl: './edi-purchased-order-card-list.component.html',
    styleUrls: ['./edi-purchased-order-card-list.component.css'],
    standalone: false
})
export class EdiPurchasedOrderCardListComponent extends ListItemRendererComponent<EdiPurchaseOrder[]> implements OnInit, AfterViewInit {
  selectedEdiOrders: EdiMessageBase[] = [];

  protected router = inject(Router);
  public ediNavigationService = inject(EdiNavigationService);

  ediNavigationBaseRoute: string;

  constructor(public actionConfigService: EdiPurchasedOrderActionConfigService) {
    super();
  }

  getIds(orders: EdiPurchaseOrder[]): string[] {
    return orders.map(o => o.id);
  }

  ngOnInit(): void {
    this.ediNavigationBaseRoute = this.router.url.split('?')[0];
  }

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }

  selectEdiOrder(order: EdiMessageBase, select: boolean) {
    const idx = this.selectedEdiOrders.findIndex(o => o.id === order.id);
    if (select && idx === -1) {
      this.selectedEdiOrders.push(order);
    } else if (!select && idx > -1) {
      this.selectedEdiOrders.splice(idx, 1);
    }
  }

  trackByFn(index: any, item: any) {
    return item.documentReferences.buyerOrder.id + '' + item.erpIds;
  }
}
